/**
 * Finance API
 * Read-only finance ledger (synced from Feishu) endpoints
 */

import apiClient from './client';
import type {
  FinanceOverview,
  ExpenseItem,
  ContributionItem,
  SyncStatus,
} from '@/types/finance';

export const financeApi = {
  getOverview: () =>
    apiClient.get<FinanceOverview>('/finance/overview').then((r) => r.data),
  getExpenses: () =>
    apiClient.get<ExpenseItem[]>('/finance/expenses').then((r) => r.data),
  getContributions: () =>
    apiClient.get<ContributionItem[]>('/finance/contributions').then((r) => r.data),
  getSyncStatus: () =>
    apiClient.get<SyncStatus>('/finance/sync-status').then((r) => r.data),
  triggerSync: () =>
    apiClient.post('/finance/sync').then((r) => r.data),
};
